import { ArrowLeft } from 'lucide-react';
import React from 'react';

interface PreviousButtonProps {
  goToPreviousStep: () => void;
  isFirstStep: boolean;
  previous: string;
}

const PreviousButton: React.FC<PreviousButtonProps> = ({ goToPreviousStep, isFirstStep, previous }) => (
  <button
    onClick={goToPreviousStep}
    disabled={isFirstStep}
    className="px-6 py-3 rounded-lg font-medium transition-all duration-200 flex items-center gap-2 bg-white text-gray-700 border border-gray-300 hover:bg-gray-50">
    <ArrowLeft className="w-4 h-4" />
    <span className="hidden sm:inline">{previous}</span>
  </button>
);

export default PreviousButton;
